import { Component, OnInit } from '@angular/core';
import { AdsService, AdStatus } from "./ads.service";
import { TableView } from '../../../helpers/tableview';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdPreview } from  './preview';
import { Auth, AuthService } from '../../login/auth.service';

import { ToastyService, ToastOptions } from 'ng2-toasty';

const debounce = <A>(f:(a:A)=>void, delay:number) => {
  let timer:any = null;

  return (a:A)=> {
    if(!timer) {
      timer = setTimeout(()=>f(a), delay);
    }else{
      clearTimeout(timer);
      timer = setTimeout(()=>f(a), delay);
    }
  }
}

@Component({
  selector: 'approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.scss'],
  providers: [AdsService]
})

export class AdminApprovalPage implements OnInit {
  public table: TableView;
  public AdStatus = AdStatus;

  public invoice: Function = debounce((item) => this._invoice(item), 1000);

  constructor(private adsService: AdsService, private modalService: NgbModal, private toastyService:ToastyService, private auth: AuthService){
  }

  ngOnInit() {
      this.table = new TableView(filter => this.adsService.getAds(filter));
      this.table.filter.sortBy = "id";
      this.table.filter.sortAsc = false;
      this.table.applyFilter();
  }

  update(item) {
    return this.table.updating = this.adsService.update(item.id, item.ad_spent_net, item.cpv_gross)
  }

  approve(item) {
    //if no device for approval is selected, automatically approve all devices (only for static!)
    if (item.approveddevices && !item.approveddevices.length && item.devices){
      item.devices.forEach(element => {
        item.approveddevices.push(element)
      });
    }
    return this.table.updating = this.adsService
    .approve(item.id, item.approveddevices, item.ad_spent_net, item.cpv_gross)
    .then(result => {
      if (result) {
        item.status = AdStatus.approved;
      }
    });
  }

  reject(item) {
    return this.table.updating = this.adsService.reject(item.id).then(result => {
      if (result) {
        item.status = AdStatus.rejected;
      }
    });
  }

  flag(item) {
    return this.table.updating = this.adsService.flag(item.id).then(result => {
      item.flag = result;
    });
  }

  _invoice(item) {
    this.adsService.invoice(item.id).then(result => {
      let toastOptions:ToastOptions = {
          title: null,
          msg: "Invoice sent to your email!",
          showClose: true,
          timeout: 5000,
          theme: "bootstrap"
      };
      this.toastyService.success(toastOptions);
    }, err => {
      let toastOptions:ToastOptions = {
          title: null,
          msg: "Some error occured!",
          showClose: true,
          timeout: 5000,
          theme: "bootstrap"
      };
      this.toastyService.error(toastOptions);
    });
  }

  preview(item) {
    let modalRef = this.modalService.open(AdPreview, {size: "lg", windowClass: "-preview"});
    modalRef.componentInstance.ad = item;
    modalRef.componentInstance.onUpdate = (item) => this.update(item).then(() => modalRef.dismiss());
    modalRef.componentInstance.onApprove = (item) => this.approve(item).then(() => modalRef.dismiss());
    modalRef.componentInstance.onReject = (item) => this.reject(item).then(() => modalRef.dismiss());
    modalRef.componentInstance.onFlag = (item) => this.flag(item).then(() => modalRef.dismiss());
    modalRef.componentInstance.onClose = () =>  modalRef.dismiss();
  }

  public admin() {
    return this.auth.getAuth().isAdmin();
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/approval/approval.component.ts